import { JSX } from 'react';
import { RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from 'src/shared/shared.types';
import { RichTextRendering } from '@ahc-digital/component-library';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';
import { checkDatasourceForRendering } from '@/shared/checkDatasourceForRendering';

export type C27RichTextAdminProps = RenderingProps<
  { RichText?: RichTextField },
  DynamicPlaceholderParams & AnchorTargetParams & TranslationOptionsParams
>;

const Default = (props?: C27RichTextAdminProps): JSX.Element => {
  const { renderRichText } = useConditionalRendering();
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  return (
    <RichTextRendering
      id={props?.params?.AnchorLinkTargetName}
      className={translationClasses(props?.params)}
      data-component={marketingRenderingName}
    >
      {renderRichText(props?.fields?.RichText)}
    </RichTextRendering>
  );
};

export default checkDatasourceForRendering<C27RichTextAdminProps>(Default);
